import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { MultilineInput } from "@Components/Input/MutlilineInput"
import { Spacer } from "@Components/Space"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { canGotoNextAtom, surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil"
import { ParentSurveyContent } from "./ParentSurveyContent"
import { SALUTANCE } from "@Services/AxiosInstance"

export const QuestionSimple = (props) => {
    const {
        axisId,
        surveyId,
        responseTypeId,
        hasPrecision,
        question,
        color,
        isChildren,
        questionNumber,
        userResponse,
        disabled,
        isParent
    } = props

    const defaultResponse = {
        axisId: axisId,
        surveyId: surveyId,
        responseTypeId: responseTypeId,
        responseValue: "",
        hasPrecision: hasPrecision,
        precisionAnswer: ""
    }

    const [responseGlobal, setResponseGlobal] = useRecoilState(surveyResponsesAtom)
    const [responseValue, setResponseValue] = useState("")
    const currentEducationalDiagnosis = useRecoilValue(currentDiagnosisAtom)
    const setCanGoToNext = useSetRecoilState(canGotoNextAtom)

    useEffect(() => {
        setCanGoToNext?.(true)
    }, [])

    const saveResponse = (texValue) => {
        setResponseGlobal((prev) => {
            if (responseGlobal?.[surveyId]) {
                return {
                    ...prev,
                    [surveyId]: { ...responseGlobal?.[surveyId], responseValue: texValue }
                }
            } else {
                return { ...prev, [surveyId]: { ...defaultResponse, responseValue: texValue } }
            }
        })
    }

    useEffect(() => {
        if (!responseGlobal?.[surveyId] && responseValue?.trim() === "") {
            saveResponse(responseValue)
        }
    }, [responseValue, responseGlobal])

    useEffect(() => {
        setResponseValue(() => {
            if (userResponse?.id > 0 && currentEducationalDiagnosis?.id > 0) {
                return userResponse?.response
            } else {
                if (responseGlobal?.[surveyId]) {
                    const prevResponse = responseGlobal?.[surveyId]?.responseValue ?? ""
                    return prevResponse
                }
                return ""
            }
        })
    }, [userResponse, responseGlobal, disabled])

    const handleChange = (texValue) => {
        setResponseValue(texValue)
        saveResponse(texValue)
    }

    if (isParent) {
        return <ParentSurveyContent question={question} />
    }

    return (
        <View style={{ padding: 20 }}>
            <OpenSansText color={color}>
                {SALUTANCE ? "QUESTION : " : !isChildren ? `QUESTION N° ${questionNumber}` : ""}
            </OpenSansText>

            <OpenSansText style={{ marginTop: 10 }} fontSize={14}>
                {question}
            </OpenSansText>

            <Spacer height={20} />

            <MultilineInput
                disabled={disabled}
                height={70}
                value={responseValue}
                onChange={(text) => handleChange(text)}
            />
        </View>
    )
}
